import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogActions,
  DialogBody,
  DialogTitle,
} from "../design/dialog";
import { useNotification } from "../contexts/NotificationContext";
import EmptyStateView from "./EmptyStateView";
import { Table, TableBody, TableCell, TableRow } from "../design/table";
import { useMatter } from "../contexts/MatterContext";
import { Notification } from "../models/Notification";
import { Button } from "../design/button";
import { useNavigate } from "react-router-dom";
import moment from "moment";

interface NotificationsDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

const NotificationsDialog: React.FC<NotificationsDialogProps> = ({
  isOpen,
  onClose,
}) => {
  const { matters } = useMatter();
  const { notifications, updateNotification } = useNotification();
  const navigate = useNavigate();

  const contentForNotification = (notification: Notification) => {
    switch (notification.type) {
      case "ADDED_TO_CASE":
        const matter = matters.find((c) => c._id === notification.matterId);
        return `You have been added to the ${matter?.name} matter`;
      case "MENTIONED_IN_COMMENT":
        const matterMention = matters.find(
          (c) => c._id === notification.matterId,
        );
        return `You have been mentioned in a comment in the ${matterMention?.name} matter`;
      default:
        return "";
    }
  };

  const handleNotificationSelect = async (notification: Notification) => {
    await updateNotification(notification._id, { isRead: true });
    switch (notification.type) {
      case "ADDED_TO_CASE":
        localStorage.setItem(
          "currentMatterId",
          notification.matterId as string,
        ); // Ensure the matterId is stored for navigation
        navigate(`/dashboard`);
        window.location.reload();
        break;
      case "MENTIONED_IN_COMMENT":
        const matterMention = matters.find(
          (c) => c._id === notification.matterId,
        );
        return `You have been mentioned in a comment in the ${matterMention?.name} matter`;
      default:
        return "";
    }
  };

  return (
    <>
      <Dialog open={isOpen} onClose={onClose}>
        <DialogTitle>Notifications</DialogTitle>
        <DialogBody>
          {notifications.length === 0 && (
            <EmptyStateView
              title="No notifications"
              message="You don't have any notifications yet."
            />
          )}
          {notifications.length > 0 && (
            <Table>
              <TableBody>
                {notifications.map((notification) => (
                  <TableRow key={notification._id}>
                    <TableCell className="flex flex-col col-span-2 space-y-1">
                      <span
                        className={
                          notification.isRead
                            ? "text-gray-500"
                            : "font-semibold"
                        }
                      >
                        {contentForNotification(notification)}
                      </span>
                      <span className="text-sm text-gray-500">
                        {moment(notification.createdAt).fromNow()}
                      </span>
                    </TableCell>
                    <TableCell className="text-right">
                      <Button
                        onClick={() => handleNotificationSelect(notification)}
                      >
                        View
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </DialogBody>
        <DialogActions className="justify-between"></DialogActions>
      </Dialog>
    </>
  );
};

export default NotificationsDialog;
